
import { TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Investment } from "@/types/investment";
import { formatCurrency } from "./utils";

interface CurrentStatusCardProps {
  investment: Investment;
}

const CurrentStatusCard = ({ investment }: CurrentStatusCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center text-green-800">
          <TrendingUp className="h-5 w-5 mr-2" />
          Current Status
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Current Balance:</span>
          <span className="font-semibold">{formatCurrency(investment.currentBalance)}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Payments Remaining:</span>
          <span className="font-semibold">{investment.remainingTerms} months</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Property Value:</span>
          <span className="font-semibold">{formatCurrency(investment.propertyValue)}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Property Type:</span>
          <span className="font-semibold">{investment.propertyType || 'Single Family'}</span>
        </div>
        <div className="flex flex-col space-y-1">
          <span className="text-gray-600">Property Description:</span>
          <span className="font-medium text-sm text-gray-800 leading-relaxed">{investment.propertyDescription || 'Contact for details'}</span>
        </div>
        
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Risk Level:</span>
          <Badge variant="secondary">{investment.riskLevel}</Badge>
        </div>
      </CardContent>
    </Card>
  );
};

export default CurrentStatusCard;
